import { defineComponent as _defineComponent } from 'vue'
import BaseQuestionMarkTooltip from "@/components-UI/BaseQuestionMarkTooltip.vue";

interface Props {
    label?: string;
    isRequired?: boolean;
    isValid?: boolean;
    hint?: string;
    hintWidth?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseListItem',
  props: {
    label: null,
    isRequired: { type: Boolean },
    isValid: { type: Boolean },
    hint: null,
    hintWidth: null
  },
  setup(__props: any) {



return { __sfc: true,BaseQuestionMarkTooltip }
}

})